/* global fbq */
import PopupInfo from './popupinfo/popupinfo.vue'
export default {
  components: {
    PopupInfo
  },
  data () {
    return {
      isOpen: false
    }
  },
  mounted () {
    fbq('track', 'InitiateCheckout')
  }
}



// WEBPACK FOOTER //
// ./src/component/landing/landing.js